import { authContract } from "@common/contracts/auth.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const authApiClient = getBackendAPIClient(authContract);

export async function login(emailOrPhoneNumber: string) {
    await authApiClient.login({
        body: {
            emailOrPhoneNumber,
        },
    });
}
